module.exports = __webpack_public_path__ + "static/media/P20.2c3b1002.svg";